import { useContext, useEffect, useState } from 'react';
import { MyContext } from '../../context';
import DataTable from '../../components/tables/DataTable';
import Pagination from '../../components/Pagination';
import { listInventoryChangeLog } from '../../utils/queries';

const PAGE_SIZE = 25;

export default function InventoryChangeLog() {
	const { activeStoreId } = useContext(MyContext);
	const [changes, setChanges] = useState([]);
	const [total, setTotal] = useState(0);
	const [page, setPage] = useState(0);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(true);
		listInventoryChangeLog({
			limit: PAGE_SIZE,
			offset: page * PAGE_SIZE,
			storeId: activeStoreId || undefined,
		}).then((result) => {
			if (result?.success) {
				setChanges(result.data.changes);
				setTotal(result.data.pagination.total);
			}
			setLoading(false);
		});
	}, [page, activeStoreId]);

	const columns = [
		{ key: 'product_name', header: 'Product' },
		{ key: 'erpProductNumber', header: 'ERP #' },
		{ key: 'location', header: 'Location' },
		{ key: 'oldQuantity', header: 'Old Qty' },
		{ key: 'newQuantity', header: 'New Qty' },
		{
			key: 'delta',
			header: 'Delta',
			render: (value) => (
				<span className={value < 0 ? 'text-pi-red' : value > 0 ? 'text-green-700' : ''}>
					{value > 0 ? `+${value}` : value}
				</span>
			),
		},
		{ key: 'changeReason', header: 'Reason' },
		{
			key: 'detectedAt',
			header: 'Detected At',
			render: (value) => (value ? new Date(value).toLocaleString() : ''),
		},
	];

	return (
		<div className='py-8 pr-8'>
			<h1 className='text-2xl font-light tracking-tight mb-6'>Inventory Change Log</h1>

			<DataTable columns={columns} data={changes} loading={loading} emptyHeading='No inventory changes found' />
			<Pagination pageCount={Math.ceil(total / PAGE_SIZE)} currentPage={page} onPageChange={setPage} />
		</div>
	);
}
